export function showToast(tag, message, title = '', options = {}) {
    const safeMessage = (message != null && String(message)) ? String(message) : '';
    const safeTitle = (title != null && String(title)) ? String(title) : '';
    const safeOptions = options != null && typeof options === 'object' ? { ...options } : {};
    return () => {
        if (typeof window.toastr !== 'undefined' && typeof window.toastr[tag] === 'function') {
            window.toastr[tag](safeMessage, safeTitle, safeOptions);
        }
    };
}



// WEBPACK FOOTER //
// ./src/incab/common/actions/toastr.js